import { message } from 'antd';

message.config({
  top: 24,
  duration: 3,
  maxCount: 3,
});

const GENERIC_TITLES = new Set([
  'success',
  'error',
  'warning',
  'info',
  'fail',
  'failed',
]);

function resolveContent(args) {
  if (typeof args === 'string') return args;
  if (args == null) return '';
  if (typeof args !== 'object') return String(args);

  const title = args.message != null ? String(args.message).trim() : '';
  const detail = args.description != null ? String(args.description).trim() : '';

  if (detail && title && !GENERIC_TITLES.has(title.toLowerCase())) {
    return `${title}: ${detail}`;
  }
  if (detail) return detail;
  return title;
}

function show(type, args) {
  const content = resolveContent(args);
  if (!content) return;
  const options =
    args && typeof args === 'object'
      ? {
          content,
          duration: args.duration,
          key: args.key,
          onClose: args.onClose,
        }
      : { content };
  return message[type](options);
}

export const notification = {
  success: (args) => show('success', args),
  error: (args) => show('error', args),
  info: (args) => show('info', args),
  warning: (args) => show('warning', args),
  warn: (args) => show('warning', args),
  open: (args) => {
    const type = args?.type && message[args.type] ? args.type : 'info';
    return show(type, args);
  },
  destroy: (...rest) => message.destroy(...rest),
  config: (...rest) => message.config(...rest),
};

export default notification;
